import React from 'react';
import { Schema } from '../../hooks/useSchema';
import { FormControl } from './FormControl';
import { FieldDefinition, MaybeFieldDefinition, OnFieldChange } from './Common';
import { ValidationErrors } from './useValidationErrors';

interface FormControlsForFieldsProps {
    fields: MaybeFieldDefinition[];
    data: any;
    schema: Schema;
    onChange: OnFieldChange;
    errors?: ValidationErrors;
    withArea?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
}

export const FormControlsForFields = (props: FormControlsForFieldsProps) => {
    const { fields, data, schema, onChange, errors, withArea, disabled, readOnly } = props;
    return <>
        {(fields.filter(fd => !!fd) as FieldDefinition[]).map(([field, extraProps]) => (
            <FormControl
                key={field}
                field={field}
                schema={schema[field]}
                row={data}
                extraProps={{ withArea, readOnly, disabled, ...extraProps}}
                onChange={onChange}
                errors={errors}
                />))}
    </>;
};
